import React, { useState } from "react";
import { Link } from "react-router-dom";
import "line-awesome/dist/line-awesome/css/line-awesome.min.css";
import menu from "assets/img/menuu.png";
import juniorlogo1 from "assets/img/Juniorlogo1.png";
import toast from "react-hot-toast";
import axios from "axios";
import { API_URL } from "assets/Contsants";

export default function Sidebar() {
  const [sidebarOpen, setSidebarOpen] = useState(true); // State to control sidebar
  const [activeItem, setActiveItem] = useState("");

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen); // Toggles the sidebar state
  };

  // Function to handle active item click
  const handleItemClick = (item) => {
    setActiveItem(item); // Updates the active item
  };

  //logout function
  const handleLogout = async (e) => {
    try {
        const token = localStorage.getItem("token") ?? '';
        
        if (!token) {
            console.warn('No token found, redirecting to login.');
            window.location.href = "/login";
            return;
        }

        //send the logout request with the token
        const response = await axios.post(`${API_URL}/api/logout`, {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        localStorage.removeItem("token");
        localStorage.removeItem("user");
        toast.success('Logged out Successfully!');
        window.location.href = "/login";

    } catch (error) {
        console.error('Logout failed:', error);
        toast.error('An error occurred!');
    }
  };

  return (
    <>
      <section className="figtree
       font-semibold">
        <div
          style={{ background: "#f7f7f7" }}
          className={`z-50 shadow text-white fixed top-0 left-0 h-screen border-r transition-all duration-300 ${
            sidebarOpen ? "w-64" : "w-20"
          }`}
        >
          <div
            className="shadow-none border-none flex justify-between items-center xl:pl-4 h-20"
            style={{ background: "#f7f7f7" }}
          >
            <a href="/homepage1">
              <img
                src={juniorlogo1}
                alt="Logo"
                className={`xl:w-10/12 transition-all ${
                  sidebarOpen ? "block" : "block"
                }`}
              />
            </a>
            {/* Toggle Button */}
            <button
              onClick={toggleSidebar}
              className=" shadow -mr-3 bg-white border text-black px-2 py-1 rounded-full focus:outline-none"
            >
              {sidebarOpen ? (
                <i className="las la-chevron-circle-left xl:text-base"></i>
              ) : (
                <i className="las la-chevron-circle-right xl:text-base"></i>
              )}
            </button>
          </div>

          <ul className="mt-8 p-4">
            <a href="/dashboard">
              <li
                className={`flex gap-2  text-base  text-black hover:bg-blue-100 active:bg-blue-100 focus:outline-none focus:ring focus:ring-blue-200 p-2 rounded ${
                  activeItem === "Dashboard" ? "bg-blue-300 text-blue-700" : ""
                }`}
                onClick={() => handleItemClick("Dashboard")}
              >
                {/* <Image src={dashboard} alt="Dashboard" className="w-5 h-5" /> */}
                <i className="las la-braille xl:text-xl"></i>
                <span
                  className={`${
                    sidebarOpen ? "inline-block" : "hidden"
                  } transition-all`}
                >
                  Dashboard
                </span>
              </li>
            </a>
            <h2 className="uppercase p-2 text-gray-400 font-semibold text-xs xl:mt-3">
              PRE SCHOOL
            </h2>

            <a href="/admissiondashboard">
              <li
                className={`flex gap-2  text-base  text-black hover:bg-blue-100 active:bg-blue-300 focus:outline-none focus:ring focus:ring-blue-300 p-2 rounded ${
                  activeItem === "AdmissionDashboard" ? "bg-blue-300 text-blue-700" : ""
                }`}
                onClick={() => handleItemClick("AdmissionDashboard")}
              >
                <i className="las la-database xl:text-xl"></i>
                <span
                  className={`${
                    sidebarOpen ? "inline-block" : "hidden"
                  } transition-all`}
                >
                  Admission
                </span>
              </li>
            </a>

            <a href="/enquirydashboard">
              <li
                className={`flex gap-2  text-base  text-black hover:bg-blue-100 active:bg-blue-300 focus:outline-none focus:ring focus:ring-blue-300 p-2 rounded ${
                  activeItem === "EnquiryDashboard" ? "bg-blue-300 text-blue-700" : ""
                }`}
                onClick={() => handleItemClick("EnquiryDashboard")}
              >
                <i className="las la-user-nurse xl:text-xl"></i>
                <span
                  className={`${
                    sidebarOpen ? "inline-block" : "hidden"
                  } transition-all`}
                >
                  Enquire
                </span>
              </li>
            </a>

            <a href="/franchisedashboard">
              <li
                className={`flex gap-2  text-base  text-black hover:bg-blue-100 active:bg-blue-300 focus:outline-none focus:ring focus:ring-blue-300 p-2 rounded ${
                  activeItem === "FranchiseDashboard" ? "bg-blue-300 text-blue-700" : ""
                }`}
                onClick={() => handleItemClick("FranchiseDashboard")}
              >
                <i className="las la-book-medical xl:text-xl"></i>
                <span
                  className={`${
                    sidebarOpen ? "inline-block" : "hidden"
                  } transition-all`}
                >
                  Franchise
                </span>
              </li>
            </a>

            <a href="/careerdashboard">
              <li
                className={`flex gap-2  text-base  text-black hover:bg-blue-100 active:bg-blue-300 focus:outline-none focus:ring focus:ring-blue-300 p-2 rounded ${
                  activeItem === "CareerDashboard" ? "bg-blue-300 text-blue-700" : ""
                }`}
                onClick={() => handleItemClick("CareerDashboard")}
              >
                <i className="las la-user xl:text-xl"></i>
                <span
                  className={`${
                    sidebarOpen ? "inline-block" : "hidden"
                  } transition-all`}
                >
                  Career
                </span>
              </li>
            </a>

            {/* <Link href="/">
              <li
                className={`flex gap-2  text-base  text-black hover:bg-blue-100 active:bg-blue-300 focus:outline-none focus:ring focus:ring-blue-300 p-2 rounded ${
                  activeItem === "Department" ? "bg-blue-300 text-blue-700" : ""
                }`}
                onClick={() => handleItemClick("Organization")}
              >
                <i className="las la-building xl:text-xl"></i>
                <span
                  className={`${
                    sidebarOpen ? "inline-block" : "hidden"
                  } transition-all`}
                >
                  Organization
                </span>
              </li>
            </Link> */}

            {/* <h2 className="uppercase p-2 text-gray-400  text-xs xl:mt-3">
              Finance
            </h2> */}

            {/* <Link href="/">
              <li
                className={`flex gap-2  text-base  text-black hover:bg-blue-100 active:bg-blue-300 focus:outline-none focus:ring focus:ring-blue-300 p-2 rounded ${
                  activeItem === "Department" ? "bg-blue-300 text-blue-700" : ""
                }`}
                onClick={() => handleItemClick("Organization")}
              >
                <i className="las la-folder xl:text-xl"></i>
                <span
                  className={`${
                    sidebarOpen ? "inline-block" : "hidden"
                  } transition-all`}
                >
                  Accounts
                </span>
              </li>
            </Link> */}

            {/* <Link href="/">
              <li
                className={`flex gap-2 text-base  text-black hover:bg-blue-100 active:bg-blue-300 focus:outline-none focus:ring focus:ring-blue-300 p-2 rounded ${
                  activeItem === "Department" ? "bg-blue-300 text-blue-700" : ""
                }`}
                onClick={() => handleItemClick("Organization")}
              >
                <i className="las la-file-invoice xl:text-xl"></i>
                <span
                  className={`${
                    sidebarOpen ? "inline-block" : "hidden"
                  } transition-all`}
                >
                  Billing
                </span>
              </li>
            </Link> */}
            <Link href="/">
              <li
                className={`flex gap-2 text-base  text-danger hover:bg-blue-100 active:bg-blue-300 focus:outline-none focus:ring focus:ring-blue-300 p-2 rounded ${
                  activeItem === "Department" ? "bg-blue-300 text-blue-700" : ""
                }`}
                onClick={() => handleLogout()}
              >
                <i className="las la-sign-out-alt xl:text-xl"></i>
                <span
                  className={`${
                    sidebarOpen ? "inline-block" : "hidden"
                  } transition-all`}
                >
                  Logout
                </span>
              </li>
            </Link>
          </ul>

          {/* endd */}
        </div>
      </section>
    </>
  );
}
